import {
  Button,
  FormFieldSet,
  PageTitle,
  ProgressTabAdv,
  useFormHandler,
} from "../../../../../../../components";
import { useState } from "react";

const PaymentStep = ({ onBack, onContinue, tabs }) => {
  const [tdsCheckBox, setTdsCheckBox] = useState([]);
  const [creditRadio, setCreditRadio] = useState("");
  const initialFormData = {
    cardNumber: "",
    expiry: "",
    holderName: "",
    cvv: "",
    paymentMode: "",
    applyTds: [],
  };

  const { formData, handleChange } = useFormHandler(initialFormData, {});

  return (
    <div className="p-5 flex flex-col flex-1 overflow-hidden">
      <div className="my-2">
        <Button
          title="Checkout"
          color="black"
          variant="text"
          size="lg"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-lg font-medium !px-2"
          onClick={onBack}
        />
      </div>

      <ProgressTabAdv tabs={tabs} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 mt-2">
        <div className="border border-gray-100 shadow-md px-4 pr-10 py-2 grid grid-cols-1 gap-3 flex-1">
          <PageTitle title={"Order Summary"} />

          {/* ATS */}
          <div className="grid grid-cols-2 items-center">
            <div>
              <span className="font-medium">ATS</span>
              <p className="text-sm">#38,400 15 Credit(s)</p>
            </div>
            <span className="text-right">22222222</span>
          </div>

          {/* Workforce */}
          <div className="grid grid-cols-2 items-center">
            <div>
              <span className="font-medium">Workforce</span>
              <p className="text-sm">2768000/User 125 Credit(s)</p>
            </div>
            <span className="text-right">1234567</span>
          </div>

          <hr className="w-full text-gray-300" />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
            {/* Apply TDS */}
            <div className="pl-5">
              <FormFieldSet
                type="checkbox"
                noTitle
                values={tdsCheckBox}
                onChange={setTdsCheckBox}
                labelPosition="after"
                options={[{ label: "Apply TDS", value: "1" }]}
              />
            </div>

            {/* Summary */}
            <div className="grid grid-cols-[1fr_auto] gap-y-2 items-center">
              <span>Sub Total</span>
              <span className="text-right whitespace-nowrap">192,000.00</span>

              <span className="text-sm">GST of 18%</span>
              <span className="text-sm text-right whitespace-nowrap">
                (+) 2,103,680.00
              </span>

              <span className="text-primary font-medium pt-3 border-t">
                Total
              </span>
              <span className="text-primary font-medium pt-3 text-right border-t whitespace-nowrap">
                212,680.00
              </span>
            </div>
          </div>
        </div>

        <div className="border px-4 py-4 border-gray-100 shadow-md flex flex-col flex-1">
          <div className="">
            <FormFieldSet
              type="radio"
              noTitle
              name="paymentmode"
              options={[
                { label: "Credit card/ Debit Card", value: 1 },
                { label: "Pay UPI", value: 2 },
              ]}
              value={creditRadio}
              onChange={(event) => setCreditRadio(event.target.value)}
            />
          </div>
          <PageTitle title={"Enter Card Detail"} tag="h6" />
          <div className="grid grid-cols-2 gap-5 mt-5 mb-5 max-[991px]:grid-cols-1">
            <FormFieldSet
              type="text"
              title="Enter Card Number"
              placeholder="Credit Card Number"
              value={formData.cardNumber}
              onChange={(val) => handleChange("cardNumber", val)}
            />

            <FormFieldSet
              type="text"
              title="Expiration Date"
              placeholder="MM/YY"
              value={formData.expiry}
              onChange={(val) => handleChange("expiry", val)}
            />
          </div>

          <div className="grid grid-cols-2 gap-5 mb-5 max-[991px]:grid-cols-1">
            <FormFieldSet
              type="text"
              title="Card Holder Name"
              placeholder="Card Holder Name"
              value={formData.holderName}
              onChange={(val) => handleChange("holderName", val)}
            />

            <FormFieldSet
              type="text"
              title="CVV"
              placeholder="Enter"
              value={formData.cvv}
              onChange={(val) => handleChange("cvv", val)}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-3 justify-end my-8">
        <Button title="Cancel" variant="outlined" onClick={onBack} />
        <Button title="Pay" onClick={onContinue} />
      </div>
    </div>
  );
};
export default PaymentStep;
